// Meta Pixel — standard implementation.
//
// IMPORTANT: the pixel must be installed in ONE place only. This module owns
// it, so the base snippet must NOT also be pasted into the published site's
// custom <head>. Two snippets = two inits = the duplicate PageView warning.
export const CLASE_PIXEL_ID = '1124176769948841'

declare global {
  interface Window {
    fbq: any
    _fbq: any
    __mpPixelPageViewSent?: boolean
    __mpPixelLeadSent?: boolean
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  window.fbq = n
  if (!window._fbq) window._fbq = n

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', CLASE_PIXEL_ID)
}

/** Fires exactly one PageView per page load. */
export function trackPageView(): void {
  if (!window.fbq || window.__mpPixelPageViewSent) return
  window.__mpPixelPageViewSent = true
  window.fbq('track', 'PageView')
}

export function trackLead(): void {
  if (!window.fbq || window.__mpPixelLeadSent) return
  window.__mpPixelLeadSent = true
  window.fbq('track', 'Lead')
}

/** Fires the Lead event on a single, specific pixel. */
export function trackLeadForPixel(pixelId: string): void {
  if (!window.fbq || window.__mpPixelLeadSent) return
  window.__mpPixelLeadSent = true
  window.fbq('trackSingle', pixelId, 'Lead')
}
